export default class gsapScroll {
    constructor(gsap, ScrollTrigger) {

        const boxes = gsap.utils.toArray('.fadeInUp');

        boxes.forEach((box, i) => {
            let anim = gsap.fromTo(box, {
                autoAlpha: 0,
                y: 50
            }, {
                duration: 1,
                autoAlpha: 1,
                y: 0
            });
            ScrollTrigger.create({
                trigger: box,
                animation: anim,
                toggleClass: {
                    targets: box,
                    className: "is-scroll"
                },
                once: true
            });
        });


        gsap.to('header', { //アニメーションしたい要素を指定
            scrollTrigger: {
                trigger: '.headerBgTrigger', //アニメーションが始まるトリガーとなる要素
                start: 'end', //アニメーションが始まる位置を指定
                end:false,
                onEnter: () => {
                    document.querySelector('header').classList.add('act');
                },
                onLeaveBack: () => {
                    document.querySelector('header').classList.remove('act');
                },
            }
        });
    }
}